import React from 'react'

const NewsInfo1 = () => {
  return (
    <>
      <section className="bg-accent section-space-less30">
        <div className="news-details-layout2">
          <div className="container">
            <div className="row mb-50-r">
              <div className="col-12">
                <div className="position-relative img-overlay-70">
                  <img src="/assets/img/news/news179.jpg" alt="news-details" className="img-fluid" />
                  <div className="topic-box-top-sm">
                    <div className="topic-box-sm color-cinnabar mb-20">स्टार न्यूज़ नेटवर्क</div>
                  </div>
                  <div className="mask-content-lg hidden-xs">
                    <ul className="post-info-light mb-10">
                      <li>
                        <a to="#" style={{ color: "white" }}>
                          <span>By</span> Admin</a>
                      </li>
                      <li>
                        <a to="#" style={{ color: "white" }}>
                          <i className="fa fa-calendar" style={{ color: "white" }} aria-hidden="true" />Jan 10, 2017</a>
                      </li>

                    </ul>
                    <h2 className="title-semibold-light size-c34 mb-40">नॉर्मल इंसान को कितना दिया जाता है एनेस्थेसिया, कितनी ज्यादा डोज पर हो जाती है मौत?</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12 col-lg-7 col-md-12 mb-30">
                <div className="item-box-light-lg mb-30">
                  <p>कर्नाटक की राजधानी बेंगलुरु से एक चौंकाने वाला मामला सामने आया है. यहां एक सर्जन पर अपनी ही पत्नी की हत्या का आरोप लगा है. <b style={{ color: "red" }}>पुलिस के अनुसार, डॉक्टर ने अपनी पत्नी को इलाज के बहाने एनेस्थेसिया की ओवरडोज दी,</b> जिससे उसकी मौत हो गई. यह घटना अप्रैल में हुई थी, लेकिन अब फोरेंसिक रिपोर्ट आने के बाद पूरा मामला अननेचुरल डेथ से मर्डर केस में बादल गया है.</p>
                  <p>कर्नाटक की राजधानी बेंगलुरु से एक चौंकाने वाला मामला सामने आया है. यहां एक सर्जन पर अपनी ही पत्नी की हत्या का आरोप लगा है. <b style={{ color: "red" }}>पुलिस के अनुसार, डॉक्टर ने अपनी पत्नी को इलाज के बहाने एनेस्थेसिया की ओवरडोज दी,</b> जिससे उसकी मौत हो गई. यह घटना अप्रैल में हुई थी, लेकिन अब फोरेंसिक रिपोर्ट आने के बाद पूरा मामला अननेचुरल डेथ से मर्डर केस में बादल गया है.</p>
                  <h2 className="title-semibold-light size-c34 mb-40" style={{ color: "red", fontWeight: "800px" }}>नॉर्मल इंसान को कितना दिया जाता है एनेस्थेसिया, कितनी ज्यादा डोज पर हो जाती है मौत?</h2>
                  <p>फोरेंसिक रिपोर्ट में महिला के शरीर में प्रोपोफॉल नामक दवा पाई गई है, जो एक इंट्रावेनस एनेस्थेटिक होती है और आमतौर पर ऑपरेशन के दौरान मरीज को बेहोश करने के लिए दी जाती है. इस घटना के बाद यह सवाल उठ रहा है कि आखिर एनेस्थेसिया की सामान्य मात्रा कितनी होती है और कितनी डोज देने पर यह जानलेवा साबित हो सकता है. ऐसे में चलिए आज हम आपको बताते हैं कि नॉर्मल इंसान को कितना एनेस्थेसिया दिया जाता है और कितनी डोज पर उसकी मौत हो सकती है.</p>
                  <p>कर्नाटक की राजधानी बेंगलुरु से एक चौंकाने वाला मामला सामने आया है. यहां एक सर्जन पर अपनी ही पत्नी की हत्या का आरोप लगा है. <b style={{ color: "red" }}>पुलिस के अनुसार, डॉक्टर ने अपनी पत्नी को इलाज के बहाने एनेस्थेसिया की ओवरडोज दी,</b> जिससे उसकी मौत हो गई. यह घटना अप्रैल में हुई थी, लेकिन अब फोरेंसिक रिपोर्ट आने के बाद पूरा मामला अननेचुरल डेथ से मर्डर केस में बादल गया है.</p>

                  <ul className="item2-inline mt-30 mb-30 block-mb">
                    <li>
                      <img src="/assets/img/news/news180.jpg" alt="news-details" className="img-fluid" />
                    </li>
                    <li>
                      <img src="/assets/img/news/news181.jpg" alt="news-details" className="img-fluid" />
                    </li>
                  </ul>
                  <blockquote cite="#" className="bg-accent mt-50 mb-50" style={{color:"green"}}>
                    <b>स्टार न्यूज़ नेटवर्क में, हम विविध विषयों पर विश्वसनीय, निष्पक्ष और समय पर समाचार प्रदान करने के लिए प्रतिबद्ध हैं। ब्रेकिंग हेडलाइन से लेकर गहन विश्लेषण तक, हम सुनिश्चित करते हैं कि हमारे दर्शक सूचित, जुड़े और सशक्त रहें।</b>
                  </blockquote>
                  <ul className="blog-tags item-inline">
                    <li>Tags</li>
                    <li>
                      <a to="#">#Business</a>
                    </li>
                    <li>
                      <a to="#">#Magazine</a>
                    </li>
                    <li>
                      <a to="#">#Lifestyle</a>
                    </li>
                  </ul>
                  <div className="post-share-area item-shadow-1">
                    <p>You can share this post!</p>
                    <ul className="social-default item-inline">
                      <li>
                        <a to="#" className="facebook">
                          <i className="fa fa-facebook" aria-hidden="true" />
                        </a>
                      </li>
                      <li>
                        <a to="#" className="twitter">
                          <i className="fa fa-instagram" aria-hidden="true" />
                        </a>
                      </li>
                      <li>
                        <a to="#" className="google">
                          <i className="fa fa-youtube" aria-hidden="true" />
                        </a>
                      </li>
                      <li>
                        <a to="#" className="pinterest">
                          <i className="fa fa-whatsapp" aria-hidden="true" />
                        </a>
                      </li>
                      <li>
                        <a to="#" className="linkedin">
                          <i className="fa fa-linkedin" aria-hidden="true" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
           
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default NewsInfo1